const singleRetrieveStages = [
    {
        id: 'initialImages',
        retrieveType: 'single',
    },
];
export default singleRetrieveStages;
